import script from "./CourtSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtSetup.vue?vue&type=script&setup=true&lang=js"

import "./CourtSetup.vue?vue&type=style&index=0&id=0f559de5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f559de5"]])

export default __exports__